
let initialState = {
  index: 0,
  started: false,
  steps: undefined,
  stepId: undefined,
  timerId: undefined,
  isTopLevel: undefined
};


export default function(state = initialState, action){

  switch(action.type){

    case "step/FINISH":
    case "@@router/LOCATION_CHANGE":
     return {
       ...initialState
     };

    case "step/START":
      return {
        ...state,
        started: true,
        index: 0,
        stepId: action.payload.id,
        steps: action.payload.steps,
        isTopLevel: true,
        timerId: action.payload.steps[0].timerId
      };

    case "step/NEXT":
      return {
        ...state,
        index:  state.index + 1 < state.steps.length?  state.index + 1 : state.index
      };

    case "step/OVERRIDE_TOP":
      return {
        ...state,
        isTopLevel: false
      };


    default: return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/step.js